import { AccessDeniedError, ApiGatewayError, BackendError, FetchApiError, GenericError, NotFoundError, RequestError, } from '@zurich-framework/core/errors';
import { ApiGatewayErrorView } from './ApiGatewayErrorView';
import { BackendErrorView } from './BackendErrorView';
import { GenericErrorView } from './GenericErrorView';
import { RequestErrorView } from './RequestErrorView';
// TODO: Implement all error views
export const errorViewHandler = (error) => {
    // Request errors
    if (error instanceof FetchApiError)
        return RequestErrorView;
    if (error instanceof BackendError)
        return BackendErrorView;
    if (error instanceof ApiGatewayError)
        return ApiGatewayErrorView;
    // Misc
    if (error instanceof AccessDeniedError)
        return GenericErrorView;
    if (error instanceof NotFoundError)
        return GenericErrorView;
    // Base types
    if (error instanceof RequestError)
        return RequestErrorView;
    if (error instanceof GenericError)
        return GenericErrorView;
};
